/*
 Flagship Global Config.
 */

const globalConfig = {
  version: "4.0.1",
  records: {
    client: {
      statuses: {
        draft: {
          label: "New Client",
          color: "black",
        },
        prospect: {
          label: "Prospect",
          color: "green",
        },
        pending: {
          label: "Pending",
          color: "blue",
        },
        closed: {
          label: "Closed Business",
          color: "yellow",
        },
        trash: {
          label: "No Longer Active",
          color: "red",
        },
      },
      defaultStatus: "prospect",
      extra1: {
        type: "user",
        required: true,
        label: "DBS",
        validation: "user",
        defaultValue: "",
        preventFocus: true,
      },
      extra2: {
        type: "text",
        multi: true,
        value: [""],
        required: false,
        label: "Account Executive(s)",
      },
      extra3: {
        type: "text",
        label: "Initial Meeting",
        required: false,
        validation: "date",
      },
      extra4: {
        type: "advisr_client",
        label: "Advisr Client ID",
        required: true,
        validation: "advisr-client",
        placeholder: "Choose a client...",
      },
    },
    rfp: {
      statuses: {
        draft: {
          label: "Draft",
          color: "black",
        },
        pending: {
          label: "Pending",
          color: "blue",
        },
        publish: {
          label: "Needs Pricing",
          color: "green",
        },
        priced: {
          label: "Pricing Complete",
          color: "blue",
        },
        proposal: {
          label: "Proposal Attached",
          color: "purple",
        },
        closed: {
          label: "Closed Business",
          color: "yellow",
        },
        insertion: {
          label: "IOs Attached",
          color: "orange",
        },
        trash: {
          label: "Canceled",
          color: "red",
        },
      },
      defaultStatus: "draft",
      extra1: {
        type: "client",
        validation: "client-name",
        label: "Client",
        required: true,
        placeholder: "Begin typing to select a client...",
      },
      extra2: {
        type: "user",
        required: true,
        label: "DBS",
        validation: "user",
        defaultValue: "",
        preventFocus: true,
      },
      extra3: {
        type: "text",
        label: "Due Date",
        required: true,
        validation: "date",
        minDatePadding: 2,
      },
    },
    io: {
      statuses: {
        draft: {
          label: "Draft",
          color: "black",
        },
        pending: {
          label: "Pending",
          color: "violet",
        },
        publish: {
          label: "Strategy Approved",
          color: "green",
        },
        received: {
          label: "All Received",
          color: "teal",
        },
        needs_materials: {
          label: "Needs Materials",
          color: "orange",
        },
        submitted: {
          label: "Submitted",
          color: "purple",
        },
        mixed: {
          label: "Some Launched",
          color: "teal",
        },
        launched: {
          label: "All Launched",
          color: "blue",
        },
        paused: {
          label: "All Paused",
          color: "yellow",
        },
        complete: {
          label: "All Complete",
          color: "grey",
        },
        trash: {
          label: "Canceled",
          color: "red",
        },
      },
      ioProductStatuses: {
        draft: {
          label: "Draft",
          color: "black",
        },
        pending: {
          label: "Pending",
          color: "violet",
        },
        publish: {
          label: "Strategy Approved",
          color: "green",
        },
        received: {
          label: "Received",
          color: "teal",
        },
        needs_materials: {
          label: "Needs Materials",
          color: "orange",
        },
        queued: {
          label: "Queued",
          color: "pink",
        },
        submitted: {
          label: "Submitted",
          color: "purple",
        },
        launched: {
          label: "Launched",
          color: "blue",
        },
        paused: {
          label: "Paused",
          color: "yellow",
        },
        complete: {
          label: "Complete",
          color: "grey",
        },
        trash: {
          label: "Canceled",
          color: "red",
        },
      },
      defaultStatus: "draft",
      extra1: {
        type: "rfp",
        validation: "rfp-number",
        label: "RFP",
        required: true,
        placeholder: "Select an RFP...",
      },
      extra2: {
        type: "user",
        label: "Market Contact",
        required: true,
        defaultValue: "",
        validation: "user",
        preventFocus: true,
      },
      extra3: {
        type: "readonly",
        label: "Submitted",
        required: false,
        defaultValue: "",
        validation: "date",
        preventFocus: true,
      },
      extra4: {
        type: "client",
        validation: "client-name",
        label: "Client",
        required: true,
        placeholder: "Begin typing to select a client...",
      },
    },
  },
  possibleActions: {
    comment: "added a comment",
    change: "made a change",
    "change-status-io": "updated an IO status",
    "change-status-rfp": "triggered an RFP status update",
    "change-business-closed": "closed business",
    "create-client": "added a Client",
    "submit-rfp": "submitted an RFP",
    "submit-io": "submitted an IO",
    "create-line-item": "added a line item",
    "update-line-item": "updated a line item",
    "create-io-product": "added an IO product",
    "update-io-product": "updated an IO product",
    "update-io-product-status": "updated an IO product status",
    "submit-io-product": "marked an IO product as submitted / ready for QA",
    "launch-io-product": "launched an IO product",
    "file-upload": "uploaded a file",
    "proposal-upload": "uploaded a proposal",
    "update-line-item-pricing": "updated line item pricing",
    "update-io-product-assignment": "updated an IO product assignment",
    "auto-subscribe-user": "auto-subscribed a user to this IO",
    "subscribe-other-user": "subscribed another user to this IO",
    "subscribe-self": "subscribed this IO",
  },
  timeTrackerTasks: [
    "Analytics",
    "Blog/Content",
    "Display",
    "Display/Social Ad Design (50/50 Split)",
    "Email Management",
    "Influencers",
    "OTT",
    "Podcasting",
    "PPC",
    "Print",
    "Quality Assurance",
    "Reputation Management",
    "SEO",
    "Social Media Management",
    "Social Media Ads",
    "Station Marketing",
    "Web",
    "Video",
    "YouTube",
    "Client Meeting",
    "Internal Meeting",
    "Market Meeting",
    "Admin",
    "Holiday",
    "Pacing",
    "Pricing/Pre-Sale",
    "Reporting",
    "Sick Time",
    "Support/Assistance",
    "Training",
    "Vacation",
    "Other/Miscellaneous",
  ],
};

export default globalConfig;



// WEBPACK FOOTER //
// ./src/config/global.js